export default __webpack_public_path__ + "static/media/logo-white.e53f1911.png";